export interface IDiagnosticsStore {
  diagnostics: any[];
}

export const diagnosticsStore = {
  diagnostics: [],
};
